import { render, staticRenderFns } from "./tenders-list.vue?vue&type=template&id=8b0a8340&scoped=true&"
import script from "./tenders-list.vue?vue&type=script&lang=js&"
export * from "./tenders-list.vue?vue&type=script&lang=js&"
import style0 from "./tenders-list.vue?vue&type=style&index=0&id=8b0a8340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0a8340",
  null
  
)

export default component.exports